// extracted by mini-css-extract-plugin
export var growableInput = "_8n-0";
export var tagContainer = "_8n-2";
export var textInput = "_8n-1";